(function () {
	'use strict';

	var module = angular.module('uwAgenda.settings.agendasettings');
	module.controller('AppointmentTypeController', ['$uibModal', '$rootScope', 'Alert', 'AppointmentTypeService', 'SharedAgendaService', 'AppointmentType', AppointmentTypeControllerFn]);

	/* controlle for main appointment types */
	function AppointmentTypeControllerFn($uibModal, $rootScope, Alert, AppointmentTypeService, SharedAgendaService, AppointmentType) {
		var vm = this;
		vm.isRingfoonAdmin = false;
		vm.isRingfoon = false;

		activate();

		// edit appointment type -> open modal
		vm.edit = showEditModal;

		function showEditModal() {

			// modal 
			var modalInstance = null;

			// open modal
			modalInstance = $uibModal.open({
				backdrop: 'static',
				keyboard: false,
				animation: true,
				templateUrl: '/app/settings/agendasettings/modules/appointmenttypes/templates/appointment-type-detail.template.html',
				controller: 'DetailAppointmentTypeController',
				controllerAs: 'vm',
				size: 'lg',
				resolve: {
					type: ['AppointmentTypeService', function (AppointmentTypeService) {
						return AppointmentTypeService.get(vm.type.id).then(function (result) {
							let type = new AppointmentType();
							type.videoconsultsActivatedInAgenda = SharedAgendaService.data.currentAgenda.videoconsultsActivated;
							type.ibanNumberOfOwner = SharedAgendaService.data.currentAgenda.owner.ibanNumber;
							type.extend(result);
							return type;
						});
					}],
					colors: ['AdministrationService', function (AdministrationService) {
						return AdministrationService.colors();
					}],
					languages: ['AdministrationService', function (AdministrationService) {
						return AdministrationService.languages();
					}],
					agendalabels: ['AgendaLabelService', 'SharedAgendaService', function (AgendaLabelService, SharedAgendaService) {
						return AgendaLabelService.query(SharedAgendaService.currentUser().agendaId, false);
					}]
				}
			});


			// when modal is closed
			modalInstance.result.then(function (item) {
				// updated item will be shown -> replace current                
				vm.overview.remove(vm.type);
				// new item to show
				var newOne = new AppointmentType();
				newOne.extend(item);
				vm.overview.add(newOne);
			}, function (result) {
				//dismissed
				if (result === 'reload') {
					// wrong user inputs -> reload modal
					showEditModal();
				}
			});

		};

		// deactivate appointment type
		vm.deactivate = function () {
			AppointmentTypeService.deactivate(vm.type.id).then(function (result) {
				// replace item
				vm.overview.remove(vm.type);
				// new one
				var item = new AppointmentType();
				item.extend(result);
				vm.overview.add(item);

				Alert.success("Appointment type was successfully deactivated");
			});
		};

		/* activation work */
		function activate() {
			vm.isRingfoonAdmin = $rootScope.isRingfoonAdmin;
			vm.isRingfoon = $rootScope.isRingfoon;
			vm.videoconsultsActivatedInAgenda = SharedAgendaService.data.currentAgenda.videoconsultsActivated;
		}
	}
})();
